import storesContext from "../contexts/StoresContext";
import React from "react";
import IStores from "../interfaces/IStores";

const useStores = (): IStores => React.useContext(storesContext);

export default useStores;
